import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Switch, Route, useHistory, useParams, Link } from 'react-router-dom';
import BrowserOnly from 'components/consumer/BrowserOnly';
import useProductAttributes from 'data-hooks/useProductAttributes';
import PDPProductDetailsModal from 'components/consumer/PDP/PDPProductDetailsModal';
const PDPDetailsAndProductCareLink = () => {
  const $ = _c(8);
  const history = useHistory();
  const {
    data: t0
  } = useProductAttributes();
  const {
    assemblyDetailsPDF
  } = t0;
  const {
    category,
    slug
  } = useParams();
  const pathToDetailsModal = `/${category}/${slug}/details`;
  const t1 = assemblyDetailsPDF ? "Details, product care & assembly instructions +" : "Details and product care +";
  let t2;
  if ($[0] !== pathToDetailsModal || $[1] !== t1) {
    t2 = <Link to={pathToDetailsModal} className="text-base font-bold text-brand cursor-pointer hover:underline">{t1}</Link>;
    $[0] = pathToDetailsModal;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== history) {
    t3 = <Switch><Route path="/:category/:slug/details"><BrowserOnly><PDPProductDetailsModal isOpen={true} onClose={() => {
            history.goBack();
          }} /></BrowserOnly></Route></Switch>;
    $[3] = history;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="PDPDetailsAndProductCareLink">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default PDPDetailsAndProductCareLink;